'use strict';

angular.module('mobile-apps').controller('LockSegmentController', [
	'$scope',
	'ModalData',
	'$modalInstance',
	function (
		$scope,
		ModalData,
		$modalInstance
	) {
		$scope.language = ModalData.language;
		$scope.locked = ModalData.locked;
		$scope.title = '';
		$scope.text = '';

		/**
		 * Close modal
		 */
		$scope.close = function () {
			$modalInstance.dismiss();
		};

		/**
		 */
		$scope.changeOne = function () {
			var returnOptions = {
				changeMany: false,
			};
			$modalInstance.close(returnOptions);
		};

		$scope.changeAll = function () {
			var returnOptions = {
				changeMany: true,
			};
			$modalInstance.close(returnOptions);
		};

		/**
		 * Initializes the needed data
		 */
		$scope.init = function () {
			$scope.initializingData = true;
			if ($scope.locked) {
				$scope.title = 'Unlock entry?';
				$scope.text = 'Unlock this entry for ' + $scope.language + ' only or for all languages?';
			} else {
				$scope.title = 'Lock entry?';
				$scope.text = 'Lock this entry for ' + $scope.language + ' only or for all languages? Locked entries will not be available for translators.';
			}
		};

		$scope.init();
	}
]);

